<div class="hidden" #templateWrapper>
    <ng-content></ng-content>
</div>
<div #renderedWrapper></div>
